// extracted by mini-css-extract-plugin
export var bodyRow = "_dz-d";
export var cardColumns = "_dz-e";
export var ellipsesOverflow = "_dz-2";
export var flatBottomCorners = "_dz-3";
export var flatTopCorners = "_dz-4";
export var headerActionsDropdown = "_dz-f";
export var headerBottomRow = "_dz-c";
export var headerTopRow = "_dz-b";
export var orderDetailsWrapper = "_dz-0";
export var orderInfoContainer = "_dz-1";
export var productDetails = "_dz-9";
export var productImage = "_dz-5";
export var responsiveTable = "_dz-8";
export var shipmentContainer = "_dz-a";
export var tableBottomLeft = "_dz-6";
export var tableBottomRight = "_dz-7";
export var trackingLink = "_dz-g";